import { Inject, ModelEvents } from '@denishussar/html5-game-engine';
import { ShopModel } from '../Models/ShopModel';
import { GameModel } from '../Models/GameModel';
import { GameLogic } from './GameLogic';
import { LivesLogic } from './LivesLogic';
import { ProductModel } from '../Services/CloudDB/Contract';
import { ModalsNames } from '../Common/MadalsManager/ModalsList';

export class ShopLogic {
    constructor(
        @Inject private _model: ShopModel,
        @Inject private _gameModel: GameModel,
        @Inject private _modelEvents: ModelEvents,
        @Inject private _gameLogic: GameLogic,
        @Inject private _livesLogic: LivesLogic,
    ) {}

    public handleClickGetLifeFromFriend() {
        this._model.canGetLifeFromFriend = false; // TODO show Friends List
    }

    public handleClickBuyButton(item: ProductModel) {
        console.log('buy pack', item.id); // TODO buy logic

        const coins = this._gameModel.userBalanceCoins;

        if (coins + item.modifiers.coins < 0) {
            this._gameLogic.modalsManager.show(ModalsNames.shop);
            //this._gameLogic.setState(GameStateEnum.shop);
            return;
        }

        if (item.modifiers.lives) {
            const lives = this._gameModel.userBalanceLivesCount;
            this._livesLogic.setLivesCount(lives + item.modifiers.lives);
        }

        if (item.modifiers.unlimLives) {
            this._livesLogic.setUnlimitedLives(item.modifiers.unlimLives);
        }

        this._gameModel.userBalanceCoins += item.modifiers.coins;
    }
}
